import { render, staticRenderFns } from "./admin-menu.vue?vue&type=template&id=8589b6c8"
import script from "./admin-menu.vue?vue&type=script&lang=ts"
export * from "./admin-menu.vue?vue&type=script&lang=ts"
import style0 from "./admin-menu.vue?vue&type=style&index=0&id=8589b6c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports